// extracted by mini-css-extract-plugin
export default {"normalPage":"NormalPage_normalPage__ZYFMk"};